module.exports = __webpack_public_path__ + "img/LoButton.0ff714f2.png";